export const formatCurrency = (value: number): string => {
  if (value >= 1e9) return `CHF ${(value / 1e9).toFixed(1)}B`
  if (value >= 1e6) return `CHF ${(value / 1e6).toFixed(1)}M`
  if (value >= 1e3) return `CHF ${(value / 1e3).toFixed(0)}K`
  return `CHF ${value.toFixed(0)}`
}

export const formatNumber = (value: number): string => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`
  }
  return value.toString()
}

export const getSwissCantonColor = (
  count: number,
  maxCount: number
): string => {
  // Generate a gradient from light blue to dark blue based on transaction count
  const intensity = count / maxCount
  const hue = 210 // Blue hue
  const saturation = 70 + intensity * 30 // 70-100%
  const lightness = 90 - intensity * 40 // 90-50%
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}
